import { useEffect, useState } from "react";
import "./Navbar.css";
import useWindowDimensions from "../../hooks/useWindowDimensions.js";

const sections = [
  { id: "home-banner", label: "Home" },
  { id: "about", label: "About Me" },
  { id: "skill", label: "Skills" },
  { id: "exprience", label: "Experience" },
  { id: "education", label: "Education" },
  { id: "volunteer", label: "Volunteer" },
  { id: "interests", label: "Interests" },
];

function Navbar() {
  const [navbarClass, setNavbarClass] = useState("navbar");
  const [activeSection, setActiveSection] = useState("home-banner");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { width } = useWindowDimensions();

  useEffect(() => {
    if (width <= 991) {
      setNavbarClass("navbar navbar-fixed-top");
      return;
    }
    if (window.pageYOffset > 735) {
      setNavbarClass("navbar navbar-fixed-top");
    } else {
      setNavbarClass("navbar");
    }
    const onScroll = () => {
      if (window.pageYOffset > 735) {
        setNavbarClass("navbar navbar-fixed-top");
      } else {
        setNavbarClass("navbar");
      }
    };
    // clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [width]);

  useEffect(() => {
    const observers = sections.map(({ id }) => {
      const el = document.getElementById(id);
      if (!el) return null;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setActiveSection(id);
          }
        },
        { rootMargin: "-40% 0px -55% 0px", threshold: 0 },
      );
      observer.observe(el);
      return observer;
    });
    return () => observers.forEach((o) => o && o.disconnect());
  }, []);

  return (
    <div className="container">
      <div id="navigation" className="menu-two">
        <div className={navbarClass}>
          <div className="navbar-header">
            <button
              type="button"
              className={`navbar-toggle${isMenuOpen ? "" : " collapsed"}`}
              onClick={() => setIsMenuOpen((prev) => !prev)}
            >
              <span className="sr-only">Toggle navigation</span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
              <span className="icon-bar"></span>
            </button>
            <div className="navbar-brand logo">
              <a href="/">
                <h3 className="topName">Mark L. Foster</h3>
              </a>
            </div>
          </div>
          <div className={`collapse navbar-collapse${isMenuOpen ? " in" : ""}`}>
            <nav id="mainmenu">
              <ul className="nav navbar-nav">
                {sections.map(({ id, label }) => (
                  <li
                    key={id}
                    className={`scroll${activeSection === id ? " current" : ""}`}
                  >
                    <a href={`#${id}`} onClick={() => setIsMenuOpen(false)}>
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Navbar;
